module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app_second"
  }, [_c('div', {
    staticClass: "table1"
  }, [_c('div', {
    staticClass: "btns"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.xinzeng()
      }
    }
  }, [_vm._v("新增排班")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "info"
    },
    on: {
      "click": _vm.edit
    }
  }, [_vm._v("编辑排班")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.delete_work_content()
      }
    }
  }, [_vm._v("删除排班")])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "新增排班",
      "visible": _vm.dialogFormVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.form
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "医  生:",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "40%"
    },
    model: {
      value: (_vm.doctorSelected),
      callback: function($$v) {
        _vm.doctorSelected = $$v
      },
      expression: "doctorSelected"
    }
  }, _vm._l((_vm.doctor), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.name
      }
    })
  }), 1), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "hidden",
      "name": "医生id"
    },
    model: {
      value: (_vm.doctorId),
      callback: function($$v) {
        _vm.doctorId = $$v
      },
      expression: "doctorId"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-top": "-40px"
    },
    attrs: {
      "label": "挂号类型:",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "40%"
    },
    model: {
      value: (_vm.form.register_selected),
      callback: function($$v) {
        _vm.$set(_vm.form, "register_selected", $$v)
      },
      expression: "form.register_selected"
    }
  }, _vm._l((_vm.form.register), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": item.type
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "9px"
    },
    attrs: {
      "label": "排班时段:"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "37%"
    },
    attrs: {
      "type": "date",
      "placeholder": "选择日期",
      "picker-options": _vm.form.pickerOptions0
    },
    model: {
      value: (_vm.form.time_selected),
      callback: function($$v) {
        _vm.$set(_vm.form, "time_selected", $$v)
      },
      expression: "form.time_selected"
    }
  }), _vm._v(" "), _c('el-time-select', {
    staticStyle: {
      "width": "20%"
    },
    attrs: {
      "placeholder": "起始时间",
      "picker-options": {
        start: '08:00',
        step: '05:00',
        end: '13:00'
      }
    },
    model: {
      value: (_vm.form.startTime),
      callback: function($$v) {
        _vm.$set(_vm.form, "startTime", $$v)
      },
      expression: "form.startTime"
    }
  }), _vm._v(" "), _c('el-time-select', {
    staticStyle: {
      "width": "20%"
    },
    attrs: {
      "placeholder": "结束时间",
      "picker-options": {
        start: '11:30',
        step: '00:30',
        end: '16:00',
        minTime: _vm.form.startTime
      }
    },
    model: {
      value: (_vm.form.endTime),
      callback: function($$v) {
        _vm.$set(_vm.form, "endTime", $$v)
      },
      expression: "form.endTime"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "排班方案:",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "40%"
    },
    model: {
      value: (_vm.planSelected),
      callback: function($$v) {
        _vm.planSelected = $$v
      },
      expression: "planSelected"
    }
  }, _vm._l((_vm.plan), function(item) {
    return _c('el-option', {
      key: item.plan_id,
      attrs: {
        "value": item.name
      }
    })
  }), 1), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "hidden",
      "name": "方案id"
    },
    model: {
      value: (_vm.planId),
      callback: function($$v) {
        _vm.planId = $$v
      },
      expression: "planId"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "50%",
      "float": "right"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#ff5435"
    }
  }, [_vm._v("温馨提示：")]), _vm._v("11:30至13:00为休息时间\n          ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.add
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "编辑排班",
      "visible": _vm.edit_dialogFormVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.edit_dialogFormVisible = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.form
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "挂号类型:",
      "label-width": _vm.formLabelWidth
    }
  }, [_vm._v(_vm._s(_vm.form.register_selected))]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "医 生:",
      "label-width": _vm.formLabelWidth
    }
  }, [_vm._v(_vm._s(_vm.form.yisheng))]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "排班时段:"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.form.selectTime) + "\n            "), _vm._v(" "), _c('el-time-select', {
    staticStyle: {
      "width": "25%"
    },
    attrs: {
      "placeholder": "起始时间",
      "picker-options": {
        start: '08:00',
        step: '05:00',
        end: '13:00'
      }
    },
    model: {
      value: (_vm.form.startTime),
      callback: function($$v) {
        _vm.$set(_vm.form, "startTime", $$v)
      },
      expression: "form.startTime"
    }
  }), _vm._v(" "), _c('el-time-select', {
    staticStyle: {
      "width": "25%"
    },
    attrs: {
      "placeholder": "结束时间",
      "picker-options": {
        start: '11:30',
        step: '00:30',
        end: '16:00',
        minTime: _vm.form.startTime
      }
    },
    model: {
      value: (_vm.form.endTime),
      callback: function($$v) {
        _vm.$set(_vm.form, "endTime", $$v)
      },
      expression: "form.endTime"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "排班方案:",
      "label-width": _vm.formLabelWidth
    }
  }, [_vm._v(_vm._s(_vm.form.schedule_plan_name))])], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.edit_dialogFormVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.edit_sure
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('table', {
    attrs: {
      "border": "1",
      "cellspacing": "0"
    }
  }, [_c('tr', {
    staticStyle: {
      "background-color": "#f2f2f2",
      "height": "50px",
      "color": "#a4a7af"
    }
  }, _vm._l((_vm.arr), function(item, index) {
    return _c('td', {
      key: index
    }, [_c('span', [_vm._v(_vm._s(item))])])
  }), 0), _vm._v(" "), _c('tr', {
    staticStyle: {
      "background-color": "#f2f2f2",
      "height": "30px",
      "color": "#a4a7af",
      "line-height": "0"
    }
  }, _vm._l((_vm.dayNames), function(item, index) {
    return _c('td', {
      key: index
    }, [_c('span', [_vm._v(_vm._s(item))]), _vm._v(" "), _c('br')])
  }), 0), _vm._v(" "), _c('tr', {
    staticClass: "td_65px"
  }, _vm._l((_vm.weeks_content), function(item, week_index) {
    return _c('td', {
      key: week_index,
      attrs: {
        "width": "10%"
      }
    }, _vm._l((item.todos), function(item1, todo_index) {
      return _c('span', {
        key: todo_index,
        class: {
          spancolor: item1.findIndex_active == 'true', isvalue: item1.doctor_selected !== '暂无排班'
        },
        on: {
          "click": function($event) {
            return _vm.find_index(week_index, todo_index)
          }
        }
      }, [_c('br'), _vm._v("\n              " + _vm._s(item1.doctor_selected) + "\n              "), _c('br'), _vm._v("\n              " + _vm._s(item1.startTime) + "\n              " + _vm._s(item1.endTime) + "\n              "), _c('br'), _vm._v("\n\t\t\t  " + _vm._s(item1.schedule_plan_name) + "\n              "), _c('br')])
    }), 0)
  }), 0)]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin": "20px 2%"
    },
    attrs: {
      "type": "info",
      "plain": ""
    },
    on: {
      "click": _vm.back
    }
  }, [_vm._v("返回")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-aa99880a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/arrange/new_add_work.vue
// module id = 1041
// module chunks = 2